import { verifyDateStringOrThrow } from './datetime';

export type HealthCardPeriod = 'day' | 'week' | 'month';

export function weekAndMonthKeysFromCalendarDay(calendarDay: string): { week: string; month: string } {
    verifyDateStringOrThrow(calendarDay);
    const [ys, ms, ds] = calendarDay.split('-');
    const y = Number(ys);
    const mo = Number(ms);
    const d = Number(ds);
    const month = `${y}-${String(mo).padStart(2, '0')}`;
    const firstOfMonthWeekday = new Date(Date.UTC(y, mo - 1, 1)).getUTCDay();
    const mondayBasedOffset = (firstOfMonthWeekday + 6) % 7;
    const weekNum = Math.floor((d - 1 + mondayBasedOffset) / 7) + 1;
    const week = `${month}-W${String(weekNum).padStart(2, '0')}`;
    return { week, month };
}

export function healthPeriodKeyForPeriod(period: HealthCardPeriod, calendarDay: string): string {
    if (period === 'day') return calendarDay;
    const { week, month } = weekAndMonthKeysFromCalendarDay(calendarDay);
    return period === 'week' ? week : month;
}

export function healthPeriodKeysForPeriods(periods: HealthCardPeriod[], calendarDay: string): string[] {
    const keys = new Set<string>();
    for (const period of periods) {
        keys.add(healthPeriodKeyForPeriod(period, calendarDay));
    }
    return [...keys];
}
